import React, { useState, useEffect } from 'react';

// Define responsive positions that avoid text overlap
const positions = [
  { 
    id: 1, 
    style: { 
      top: '15%', 
      left: '5%',
      // Hide on small screens to avoid text overlap
      '@media (max-width: 768px)': { display: 'none' }
    } 
  },
  { 
    id: 2, 
    style: { 
      top: '65%', 
      left: '8%',
      // Move lower on mobile
      '@media (max-width: 768px)': { top: '75%', left: '10%' }
    } 
  },
  { 
    id: 3, 
    style: { 
      top: '10%', 
      right: '5%',
      // Hide on small screens to avoid text overlap
      '@media (max-width: 768px)': { display: 'none' }
    } 
  },
  { 
    id: 4, 
    style: { 
      top: '65%', 
      right: '8%',
      // Move lower on mobile
      '@media (max-width: 768px)': { top: '75%', right: '10%' }
    } 
  }
];

// Define completion icons that can be randomly selected
const completionIcons = [
  {
    id: 'checkmark',
    component: (
      <svg 
        width="60" 
        height="60" 
        viewBox="0 0 94 94" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="drop-shadow-lg hover:scale-110 transition-transform duration-300"
      >
        <path d="M33.2917 48.9583L41.125 56.7916L60.7083 37.2083" stroke="#00d084" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M86.1667 46.9999C86.1667 65.4631 86.1667 74.6951 80.4307 80.4306C74.6952 86.1666 65.4632 86.1666 47 86.1666C28.5366 86.1666 19.305 86.1666 13.5692 80.4306C7.83334 74.6951 7.83334 65.4631 7.83334 46.9999C7.83334 28.5366 7.83334 19.3049 13.5692 13.5691C19.305 7.83325 28.5366 7.83325 47 7.83325C65.4632 7.83325 74.6952 7.83325 80.4307 13.5691C84.2448 17.3829 85.5228 22.7422 85.9509 31.3333" stroke="#7F7CA3" strokeWidth="5" strokeLinecap="round"/>
      </svg>
    ),
    statusText: "Complete!",
    statusColor: "#10b981"
  },
  {
    id: 'heart',
    component: (
      <svg 
        width="60" 
        height="60" 
        viewBox="0 0 96 96" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="drop-shadow-lg hover:scale-110 transition-transform duration-300"
      >
        <path d="M48 38.0029L45.8564 40.1017C46.4208 40.6781 47.1932 41.0029 48 41.0029C48.8068 41.0029 49.5792 40.6781 50.1436 40.1017L48 38.0029ZM42.058 57.4857C39.7317 55.5065 37.3964 53.2141 35.6654 50.8437C33.899 48.4245 33 46.2481 33 44.4373H27C27 48.1001 28.7386 51.5317 30.8197 54.3821C32.9361 57.2805 35.6579 59.9181 38.1704 62.0557L42.058 57.4857ZM33 44.4373C33 40.0065 34.9782 37.6732 37.0133 36.9122C39.0821 36.1386 42.3804 36.5515 45.8564 40.1017L50.1436 35.904C45.52 31.1819 39.8182 29.4576 34.9119 31.2922C29.972 33.1394 27 38.1596 27 44.4373H33ZM57.8296 62.0557C60.342 59.9181 63.064 57.2805 65.1804 54.3821C67.2616 51.5317 69 48.1001 69 44.4373H63C63 46.2481 62.1008 48.4249 60.3348 50.8437C58.6036 53.2145 56.2684 55.5065 53.942 57.4857L57.8296 62.0557ZM69 44.4373C69 38.1595 66.028 33.1393 61.088 31.2922C56.1816 29.4576 50.48 31.1819 45.8564 35.904L50.1436 40.1017C53.6196 36.5515 56.918 36.1386 58.9868 36.9122C61.022 37.6732 63 40.0065 63 44.4373H69ZM38.1704 62.0557C41.2884 64.7081 43.7712 66.9757 48 66.9757V60.9757C46.344 60.9757 45.5312 60.4401 42.058 57.4857L38.1704 62.0557ZM53.942 57.4857C50.4688 60.4401 49.656 60.9757 48 60.9757V66.9757C52.2288 66.9757 54.7116 64.7081 57.8296 62.0557L53.942 57.4857Z" fill="#00d084"/>
        <path d="M68 13.3513C62.1164 9.94788 55.2856 8 48 8C25.9086 8 8 25.9086 8 48C8 54.3988 9.50248 60.4464 12.1738 65.81C12.8838 67.2352 13.12 68.8644 12.7085 70.4024L10.326 79.3068C9.2918 83.172 12.828 86.708 16.6934 85.674L25.5976 83.2916C27.1357 82.88 28.7648 83.1164 30.1901 83.826C35.5535 86.4976 41.6012 88 48 88C70.0912 88 88 70.0912 88 48C88 40.7144 86.052 33.8835 82.6488 28" stroke="#7F7CA3" strokeWidth="5" strokeLinecap="round"/>
      </svg>
    ),
    statusText: "Loved!",
    statusColor: "#10b981"
  }
];

export const InteractiveIcons: React.FC = () => {
  const [showQR, setShowQR] = useState(false);
  const [showAI, setShowAI] = useState(false);
  const [showCompletion, setShowCompletion] = useState(false);
  const [, setAnimationCycle] = useState(0);
  const [qrPosition, setQrPosition] = useState(positions[0]);
  const [aiPosition, setAiPosition] = useState(positions[1]);
  const [completionPosition, setCompletionPosition] = useState(positions[2]);
  const [selectedCompletionIcon, setSelectedCompletionIcon] = useState(completionIcons[0]);

  useEffect(() => {
    const getRandomPositions = () => {
      // Randomly select three different positions
      const availablePositions = [...positions];
      
      // Select QR position
      const qrIndex = Math.floor(Math.random() * availablePositions.length);
      const qrPos = availablePositions[qrIndex];
      availablePositions.splice(qrIndex, 1);
      
      // Select AI position
      const aiIndex = Math.floor(Math.random() * availablePositions.length);
      const aiPos = availablePositions[aiIndex];
      availablePositions.splice(aiIndex, 1);
      
      // Select Completion position
      const completionIndex = Math.floor(Math.random() * availablePositions.length);
      const completionPos = availablePositions[completionIndex];
      
      return { qrPos, aiPos, completionPos };
    };

    const getRandomCompletionIcon = () => {
      const randomIndex = Math.floor(Math.random() * completionIcons.length);
      return completionIcons[randomIndex];
    };

    const startAnimation = () => {
      // Reset
      setShowQR(false);
      setShowAI(false);
      setShowCompletion(false);
      
      // Get new random positions and completion icon
      const { qrPos, aiPos, completionPos } = getRandomPositions();
      setQrPosition(qrPos);
      setAiPosition(aiPos);
      setCompletionPosition(completionPos);
      setSelectedCompletionIcon(getRandomCompletionIcon());
      
      // QR appears first
      setTimeout(() => setShowQR(true), 1000);
      
      // AI appears after QR
      setTimeout(() => setShowAI(true), 3000);
      
      // Completion icon appears after AI
      setTimeout(() => setShowCompletion(true), 4000);
      
      // QR hides first
      setTimeout(() => setShowQR(false), 6000);
      
      // AI hides after QR
      setTimeout(() => setShowAI(false), 6500);
      
      // Completion icon hides last
      setTimeout(() => {
        setShowCompletion(false);
        setAnimationCycle(prev => prev + 1);
      }, 7000);
    };

    startAnimation();
    
    // Repeat every 8 seconds
    const interval = setInterval(startAnimation, 8000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Desktop version - full interactive icons */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden 
                    hidden md:block">{/* Show only on desktop */}
      {/* QR Code Icon - positioned randomly */}
      <div 
        className={`absolute transition-all duration-1000 transform ${
          showQR 
            ? 'opacity-100 translate-y-0 scale-100 rotate-0' 
            : 'opacity-0 translate-y-10 scale-75 rotate-12'
        }`}
        style={{
          ...qrPosition.style,
          zIndex: 5
        }}
      >
        <div className="relative">
          {/* Scan line effect */}
          <div 
            className={`absolute inset-0 bg-gradient-to-r from-transparent via-purple-300 to-transparent h-1 transition-transform duration-2000 ${
              showQR ? 'animate-scan' : ''
            }`}
            style={{ top: '50%' }}
          />
          
          <svg 
            width="70" 
            height="70" 
            viewBox="0 0 106 106" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="drop-shadow-lg hover:scale-110 transition-transform duration-300"
          >
            <path d="M71.4028 26.4999C70.9962 26.4999 70.6667 26.8295 70.6667 27.236V34.5971C70.6667 35.0037 70.9962 35.3332 71.4028 35.3332H78.7639C79.1704 35.3332 79.5 35.0037 79.5 34.5971V27.236C79.5 26.8295 79.1704 26.4999 78.7639 26.4999H71.4028ZM70.6667 79.4999V77.2916C70.6667 76.0719 71.6554 75.0832 72.875 75.0832C74.0946 75.0832 75.0833 76.0719 75.0833 77.2916V79.4999H79.5V77.2916C79.5 76.0719 80.4887 75.0832 81.7083 75.0832C82.9279 75.0832 83.9167 76.0719 83.9167 77.2916V81.7082C83.9167 82.9279 82.9279 83.9166 81.7083 83.9166H64.0417C62.822 83.9166 61.8333 82.9279 61.8333 81.7082V77.2916C61.8333 76.0719 62.822 75.0832 64.0417 75.0832C65.2613 75.0832 66.25 76.0719 66.25 77.2916V79.4999H70.6667ZM57.4167 48.5832H59.625C60.8446 48.5832 61.8333 49.572 61.8333 50.7916C61.8333 52.0112 60.8446 52.9999 59.625 52.9999H50.7917C49.572 52.9999 48.5833 52.0112 48.5833 50.7916C48.5833 49.572 49.572 48.5832 50.7917 48.5832H53V44.1666H46.375C45.1554 44.1666 44.1667 43.1779 44.1667 41.9582C44.1667 40.7386 45.1554 39.7499 46.375 39.7499H59.625C60.8446 39.7499 61.8333 40.7386 61.8333 41.9582C61.8333 43.1779 60.8446 44.1666 59.625 44.1666H57.4167V48.5832ZM79.5 52.9999H77.2917C76.072 52.9999 75.0833 52.0112 75.0833 50.7916C75.0833 49.572 76.072 48.5832 77.2917 48.5832H79.5V46.3749C79.5 45.1553 80.4887 44.1666 81.7083 44.1666C82.9279 44.1666 83.9167 45.1553 83.9167 46.3749V55.2082C83.9167 56.4279 82.9279 57.4166 81.7083 57.4166C80.4887 57.4166 79.5 56.4279 79.5 55.2082V52.9999ZM57.4167 61.8332H55.2083C53.9887 61.8332 53 60.8445 53 59.6249C53 58.4053 53.9887 57.4166 55.2083 57.4166H59.625C60.8446 57.4166 61.8333 58.4053 61.8333 59.6249V68.4582C61.8333 69.6779 60.8446 70.6666 59.625 70.6666H46.375C45.1554 70.6666 44.1667 69.6779 44.1667 68.4582C44.1667 67.2386 45.1554 66.2499 46.375 66.2499H57.4167V61.8332ZM71.4028 22.0833H78.7639C81.6097 22.0833 83.9167 24.3902 83.9167 27.236V34.5971C83.9167 37.4429 81.6097 39.7499 78.7639 39.7499H71.4028C68.557 39.7499 66.25 37.4429 66.25 34.5971V27.236C66.25 24.3902 68.557 22.0833 71.4028 22.0833ZM27.2361 22.0833H34.5972C37.443 22.0833 39.75 24.3902 39.75 27.236V34.5971C39.75 37.4429 37.443 39.7499 34.5972 39.7499H27.2361C24.3903 39.7499 22.0833 37.4429 22.0833 34.5971V27.236C22.0833 24.3902 24.3903 22.0833 27.2361 22.0833ZM27.2361 26.4999C26.8296 26.4999 26.5 26.8295 26.5 27.236V34.5971C26.5 35.0037 26.8296 35.3332 27.2361 35.3332H34.5972C35.0038 35.3332 35.3333 35.0037 35.3333 34.5971V27.236C35.3333 26.8295 35.0038 26.4999 34.5972 26.4999H27.2361ZM27.2361 66.2499H34.5972C37.443 66.2499 39.75 68.5569 39.75 71.4027V78.7638C39.75 81.6096 37.443 83.9166 34.5972 83.9166H27.2361C24.3903 83.9166 22.0833 81.6096 22.0833 78.7638V71.4027C22.0833 68.5569 24.3903 66.2499 27.2361 66.2499ZM27.2361 70.6666C26.8296 70.6666 26.5 70.9961 26.5 71.4027V78.7638C26.5 79.1703 26.8296 79.4999 27.2361 79.4999H34.5972C35.0038 79.4999 35.3333 79.1703 35.3333 78.7638V71.4027C35.3333 70.9961 35.0038 70.6666 34.5972 70.6666H27.2361ZM57.4167 26.4999H46.375C45.1554 26.4999 44.1667 25.5112 44.1667 24.2916C44.1667 23.072 45.1554 22.0833 46.375 22.0833H59.625C60.8446 22.0833 61.8333 23.072 61.8333 24.2916V33.1249C61.8333 34.3445 60.8446 35.3332 59.625 35.3332C58.4054 35.3332 57.4167 34.3445 57.4167 33.1249V26.4999ZM46.375 35.3332C45.1554 35.3332 44.1667 34.3445 44.1667 33.1249C44.1667 31.9053 45.1554 30.9166 46.375 30.9166H50.7917C52.0113 30.9166 53 31.9053 53 33.1249C53 34.3445 52.0113 35.3332 50.7917 35.3332H46.375ZM24.2917 61.8332C23.072 61.8332 22.0833 60.8445 22.0833 59.6249C22.0833 58.4053 23.072 57.4166 24.2917 57.4166H33.125C34.3446 57.4166 35.3333 58.4053 35.3333 59.6249C35.3333 60.8445 34.3446 61.8332 33.125 61.8332H24.2917ZM41.9583 61.8332C40.7387 61.8332 39.75 60.8445 39.75 59.6249C39.75 58.4053 40.7387 57.4166 41.9583 57.4166H46.375C47.5946 57.4166 48.5833 58.4053 48.5833 59.6249C48.5833 60.8445 47.5946 61.8332 46.375 61.8332H41.9583ZM48.5833 79.4999V81.7082C48.5833 82.9279 47.5946 83.9166 46.375 83.9166C45.1554 83.9166 44.1667 82.9279 44.1667 81.7082V77.2916C44.1667 76.0719 45.1554 75.0832 46.375 75.0832H55.2083C56.428 75.0832 57.4167 76.0719 57.4167 77.2916C57.4167 78.5112 56.428 79.4999 55.2083 79.4999H48.5833ZM39.75 48.5832H41.9583C43.178 48.5832 44.1667 49.572 44.1667 50.7916C44.1667 52.0112 43.178 52.9999 41.9583 52.9999H37.5417C36.322 52.9999 35.3333 52.0112 35.3333 50.7916V48.5832H33.125C31.9054 48.5832 30.9167 47.5945 30.9167 46.3749C30.9167 45.1553 31.9054 44.1666 33.125 44.1666H37.5417C38.7613 44.1666 39.75 45.1553 39.75 46.3749V48.5832ZM22.0833 46.3749C22.0833 45.1553 23.072 44.1666 24.2917 44.1666C25.5113 44.1666 26.5 45.1553 26.5 46.3749V50.7916C26.5 52.0112 25.5113 52.9999 24.2917 52.9999C23.072 52.9999 22.0833 52.0112 22.0833 50.7916V46.3749ZM66.25 46.3749C66.25 45.1553 67.2387 44.1666 68.4583 44.1666C69.6779 44.1666 70.6667 45.1553 70.6667 46.3749V55.2082C70.6667 56.4279 69.6779 57.4166 68.4583 57.4166C67.2387 57.4166 66.25 56.4279 66.25 55.2082V46.3749ZM75.0833 66.2499V64.0416C75.0833 62.8219 76.072 61.8332 77.2917 61.8332H81.7083C82.9279 61.8332 83.9167 62.8219 83.9167 64.0416C83.9167 65.2612 82.9279 66.2499 81.7083 66.2499H79.5V68.4582C79.5 69.6779 78.5113 70.6666 77.2917 70.6666H68.4583C67.2387 70.6666 66.25 69.6779 66.25 68.4582V64.0416C66.25 62.8219 67.2387 61.8332 68.4583 61.8332C69.6779 61.8332 70.6667 62.8219 70.6667 64.0416V66.2499H75.0833ZM13.25 28.7082C13.25 29.9279 12.2613 30.9166 11.0417 30.9166C9.82203 30.9166 8.83333 29.9279 8.83333 28.7082V19.8749C8.83333 13.7768 13.7768 8.83325 19.875 8.83325H28.7083C29.928 8.83325 30.9167 9.82196 30.9167 11.0416C30.9167 12.2612 29.928 13.2499 28.7083 13.2499H19.875C16.2161 13.2499 13.25 16.216 13.25 19.8749V28.7082ZM77.2917 13.2499C76.072 13.2499 75.0833 12.2612 75.0833 11.0416C75.0833 9.82196 76.072 8.83325 77.2917 8.83325H86.125C92.2231 8.83325 97.1666 13.7768 97.1666 19.8749V28.7082C97.1666 29.9279 96.1779 30.9166 94.9583 30.9166C93.7387 30.9166 92.75 29.9279 92.75 28.7082V19.8749C92.75 16.216 89.7839 13.2499 86.125 13.2499H77.2917ZM28.7083 92.7499C29.928 92.7499 30.9167 93.7386 30.9167 94.9582C30.9167 96.1779 29.928 97.1666 28.7083 97.1666H19.875C13.7768 97.1666 8.83333 92.2231 8.83333 86.1249V77.2916C8.83333 76.0719 9.82203 75.0832 11.0417 75.0832C12.2613 75.0832 13.25 76.0719 13.25 77.2916V86.1249C13.25 89.7838 16.2161 92.7499 19.875 92.7499H28.7083ZM92.75 77.2916C92.75 76.0719 93.7387 75.0832 94.9583 75.0832C96.1779 75.0832 97.1666 76.0719 97.1666 77.2916V86.1249C97.1666 92.2231 92.2231 97.1666 86.125 97.1666H77.2917C76.072 97.1666 75.0833 96.1779 75.0833 94.9582C75.0833 93.7386 76.072 92.7499 77.2917 92.7499H86.125C89.7839 92.7499 92.75 89.7838 92.75 86.1249V77.2916Z" 
              fill="#7F7CA3"
            />
          </svg>
          
          {/* Ripple effect for QR scanning */}
          <div 
            className={`absolute inset-0 rounded-full border-2 border-green-400 ${
              showQR ? 'animate-ping' : 'opacity-0'
            }`}
            style={{ 
              width: '110px', 
              height: '110px', 
              top: '-20px', 
              left: '-20px',
              animationDuration: '2s'
            }}
          />
        </div>
      </div>

      {/* AI Icon - positioned randomly */}
      <div 
        className={`absolute transition-all duration-1000 transform ${
          showAI 
            ? 'opacity-100 translate-y-0 scale-100 rotate-0' 
            : 'opacity-0 translate-y-10 scale-75 rotate-12'
        }`}
        style={{
          ...aiPosition.style,
          zIndex: 5
        }}
      >
        <div className="relative">
          <svg 
            width="55" 
            height="55" 
            viewBox="0 0 52 52" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="drop-shadow-lg hover:scale-110 transition-transform duration-300"
          >
            <path d="M25.122 10.857C22.6185 8.3526 20.9049 3.97922 20.0545 0C19.2028 3.98003 17.4911 8.35433 14.9867 10.8588C12.4831 13.3615 8.10844 15.075 4.13004 15.9271C8.11007 16.7775 12.484 18.4901 14.9875 20.9946C17.491 23.4981 19.2046 27.8724 20.0563 31.8516C20.9066 27.8716 22.6197 23.4973 25.1228 20.9929C27.6263 18.4894 32.001 16.7766 35.9794 15.9245C32.0003 15.0741 27.6264 13.3606 25.122 10.857Z" 
              fill="#7F7CA3"
            />
            <path d="M41.3838 30.9095C39.8894 29.4144 38.864 26.8003 38.356 24.4233C37.8471 26.8003 36.8251 29.4143 35.3291 30.9103C33.8331 32.4047 31.2195 33.4292 28.8429 33.9381C31.2203 34.4469 33.8331 35.4698 35.3291 36.9658C36.8251 38.461 37.8489 41.075 38.3577 43.452C38.8656 41.0741 39.8894 38.461 41.3845 36.965C42.8797 35.4698 45.4937 34.446 47.8699 33.9364C45.4938 33.4284 42.8798 32.4047 41.3838 30.9095Z" 
              fill="#7F7CA3"
            />
            <path d="M14.8639 36.0244C14.4366 38.0199 13.5786 40.2152 12.3229 41.4708C11.0674 42.7255 8.873 43.5853 6.87781 44.0126C8.873 44.4408 11.0674 45.298 12.3229 46.5544C13.5786 47.8099 14.4383 50.0035 14.8656 52C15.2925 50.0035 16.1509 47.81 17.407 46.5536C18.6617 45.2981 20.8565 44.4391 22.8513 44.011C20.8566 43.5844 18.6617 42.7256 17.4062 41.47C16.1509 40.2153 15.2907 38.02 14.8639 36.0244Z" 
              fill="#7F7CA3"
            />
          </svg>
          
          {/* AI processing sparkles */}
          <div 
            className={`absolute transition-all duration-1000 ${
              showAI ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div className="absolute -top-2 -right-2 w-3 h-3 rounded-full animate-pulse" style={{ animationDelay: '0.2s', backgroundColor: '#00d084' }} />
            <div className="absolute -bottom-2 -left-2 w-2 h-2 rounded-full animate-pulse" style={{ animationDelay: '0.4s', backgroundColor: '#00d084' }} />
            <div className="absolute top-1/2 -right-3 w-1 h-1 rounded-full animate-pulse" style={{ animationDelay: '0.6s', backgroundColor: '#00d084' }} />
          </div>
        </div>
      </div>

      {/* Completion Icon - positioned randomly (checkmark, heart, or other icons) */}
      <div 
        className={`absolute transition-all duration-1000 transform ${
          showCompletion 
            ? 'opacity-100 translate-y-0 scale-100 rotate-0' 
            : 'opacity-0 translate-y-10 scale-75 rotate-12'
        }`}
        style={{
          ...completionPosition.style,
          zIndex: 5
        }}
      >
        <div className="relative">
          {selectedCompletionIcon.component}
        </div>
      </div>

      {/* Process indicator text - moved further from icons */}
      <div 
        className={`absolute transition-all duration-1000 ${
          showCompletion ? 'opacity-100 translate-y-0' : 'opacity-50 translate-y-4'
        }`}
        style={{
          bottom: '8%',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 5
        }}
      >
        <div className="text-center">
          <div className="text-sm font-medium text-gray-600 mb-1">
            {showQR && !showAI && !showCompletion && "Scanning..."}
            {showAI && !showCompletion && "Processing with AI"}
            {showCompletion && selectedCompletionIcon.statusText}
          </div>
          <div className="flex justify-center space-x-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-2 h-2 rounded-full transition-all duration-300"
                style={{
                  animationDelay: `${i * 0.2}s`,
                  animation: (showQR || showAI || showCompletion) ? 'pulse 1.5s infinite' : 'none',
                  backgroundColor: showCompletion ? selectedCompletionIcon.statusColor : '#7F7CA3'
                }}
              />
            ))}
          </div>
        </div>
      </div>
      </div>
      
      {/* Mobile version - simplified corners only */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden 
                    block md:hidden">  {/* Show only on mobile */}
        {/* Top left corner animation */}
        <div 
          className="absolute top-4 left-4 opacity-30"
          style={{ zIndex: 1 }}
        >
          <div className="animate-pulse">
            <svg 
              width="30" 
              height="30" 
              viewBox="0 0 52 52" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M25.122 10.857C22.6185 8.3526 20.9049 3.97922 20.0545 0C19.2028 3.98003 17.4911 8.35433 14.9867 10.8588C12.4831 13.3615 8.10844 15.075 4.13004 15.9271C8.11007 16.7775 12.484 18.4901 14.9875 20.9946C17.491 23.4981 19.2046 27.8724 20.0563 31.8516C20.9066 27.8716 22.6197 23.4973 25.1228 20.9929C27.6263 18.4894 32.001 16.7766 35.9794 15.9245C32.0003 15.0741 27.6264 13.3606 25.122 10.857Z" 
                fill="#7F7CA3"
                opacity="0.6"
              />
            </svg>
          </div>
        </div>
        
        {/* Top right corner animation */}
        <div 
          className="absolute top-4 right-4 opacity-30"
          style={{ zIndex: 1 }}
        >
          <div className="animate-pulse" style={{ animationDelay: '1s' }}>
            <svg 
              width="25" 
              height="25" 
              viewBox="0 0 94 94" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M33.2917 48.9583L41.125 56.7916L60.7083 37.2083" stroke="#00d084" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
              <path d="M86.1667 46.9999C86.1667 65.4631 86.1667 74.6951 80.4307 80.4306C74.6952 86.1666 65.4632 86.1666 47 86.1666C28.5366 86.1666 19.305 86.1666 13.5692 80.4306C7.83334 74.6951 7.83334 65.4631 7.83334 46.9999C7.83334 28.5366 7.83334 19.3049 13.5692 13.5691C19.305 7.83325 28.5366 7.83325 47 7.83325C65.4632 7.83325 74.6952 7.83325 80.4307 13.5691C84.2448 17.3829 85.5228 22.7422 85.9509 31.3333" stroke="#7F7CA3" strokeWidth="3" strokeLinecap="round" opacity="0.6"/>
            </svg>
          </div>
        </div>
      </div>
    </>
  );
}; 